window.onload = function () {


};

// ページの読み込みと解析が完了した後に有効になる処理を記述
window.addEventListener('DOMContentLoaded', function (e) {

    // カテゴリーコンボボックス変更時の処理
    $(document).on('change', '#select_category', function () {
        if (!$('#select_category').val()) {
            // 価格帯コンボボックスの更新
            var prices = '<select name="select[price]" id="select_price"><option value="">--</option>';
            prices += '</select>';
        } else {
            // 価格帯コンボボックスの更新
            var prices = '<select name="select[price]" id="select_price"><option value="">--</option>';
            for (var i = 0; i < data.priceRanges.length; i++) {
                prices += '<option value=\"' + data.priceRanges[i].url_name + '\">&yen;' + data.priceRanges[i].price_from.toLocaleString() + '～' + (data.priceRanges[i].price_to != -1 ? '&yen;' + data.priceRanges[i].price_to.toLocaleString() : '') + '</option>';
            }
            prices += '</select>';
        }
        console.log(prices);
        $('#select_price').replaceWith(prices);
    });


    // 検索ボタンを押したときの処理
    $(document).on('click', '#execute_search', function () {
        let to_url;
        to_url = window.location.protocol + '//' + window.location.host + window.location.pathname.substr(0, window.location.pathname.indexOf('/i/') + 3);
        console.log(to_url);
        if ($('#select_category').val()) {
            to_url = to_url + $('#select_category').val() + '/';
        }
        if ($('#select_price').val()) {
            to_url = to_url + '?price=' + $('#select_price').val();
        }
        if ((!$('#select_category').val() && !$('#select_price').val())) {
            to_url = window.location.protocol + '//' + window.location.host + window.location.pathname.substr(0, window.location.pathname.indexOf('/i/'));
        }
        console.log('goto ' + to_url);
        window.location.href = to_url;
    });
});
